import { isNil } from "lodash";

const pristineKeys = new WeakMap();

const clearTimers = (win) => {
  const last = win.setTimeout(() => undefined, 0);
  for (let id = 0; id <= last; id += 1) {
    win.clearTimeout(id);
    win.clearInterval(id);
  }
};

export const resetFrameWindow = (win) => {
  if (isNil(win)) return;
  const pristine = pristineKeys.get(win);
  if (isNil(pristine)) {
    pristineKeys.set(win, new Set(Object.getOwnPropertyNames(win)));
    return;
  }
  for (const key of Object.getOwnPropertyNames(win)) {
    if (!pristine.has(key)) Reflect.deleteProperty(win, key);
  }
  clearTimers(win);
};
